(function (ws) {
    'use strict';
    ws.views.helpTooltipView = Backbone.View.extend({

        events: {
            'mouseover .help-tooltip-content': 'showTooltip',
            'mouseout .help-tooltip-content': 'hideTooltip',
            'touchstart .help-tooltip-content': 'showTooltip',
            'touchend .help-tooltip-content': 'hideTooltip'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$helpTooltip = this.$('.help-tooltip-content .tooltip');
        },

        /**
         * Show Tooltip for help notes
         * @param {Object} e
         */
        showTooltip: function (e) {
            e.preventDefault();
            var tooltip = $(e.currentTarget).children('.tooltip');
            tooltip.show();
        },

        /**
         * Hide Tooltip for help notes
         */
        hideTooltip: function () {
            this.$helpTooltip.hide();
        }
    });
})(westcon);
